
import Vue from 'vue';
import store from '@/store';
import SubCategoryComponent from '@/components/SubCategoryComponent.vue';

export default Vue.extend({
  name: 'ConfiguratorMobileSubcategoryCollapse',
  store,
  components: {
    SubCategoryComponent,
  },
  props: {
    collapseId: String,
    subcategory: Array,
  },
  data() {
    return {
    };
  },
});
